import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { infoDetailsProps } from "types/models/infoDetailsProps";

type State = {
  data: any;
  idDiagnose: number | string;
  idReceipt: number | string;
  isCallResultDiagnose: boolean;
  TGCDDiagnose: any;
};

const initialState: State = {
  data: null,
  idDiagnose: null,
  idReceipt: null,
  isCallResultDiagnose: false,
  TGCDDiagnose: null,
};

export const diagnoseSlice = createSlice({
  name: "residentialNurse",
  initialState: initialState,
  reducers: {
    setDataDiagnose: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        data: actions.payload,
      };
    },
    setIdDiagnose: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        idDiagnose: actions.payload,
      };
    },
    setIdReceiptDiagnose: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        idReceipt: actions.payload,
      };
    },
    setIsCallResultDiagnose: (
      state = initialState,
      actions: PayloadAction<any>
    ) => {
      return {
        ...state,
        isCallResultDiagnose: actions.payload,
      };
    },
    setTGCDDiagnose: (state = initialState, actions: PayloadAction<any>) => {
      return {
        ...state,
        TGCDDiagnose: actions.payload,
      };
    },
  },
});

export const {
  setDataDiagnose,
  setIdDiagnose,
  setIsCallResultDiagnose,
  setIdReceiptDiagnose,
  setTGCDDiagnose,
} = diagnoseSlice.actions;
export default diagnoseSlice.reducer;
